import script from "./ActivationResult.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivationResult.vue?vue&type=script&setup=true&lang=js"

import "./ActivationResult.vue?vue&type=style&index=0&id=5014c255&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5014c255"]])

export default __exports__